import PaginationArrows from "./pagination/PaginationArrows";

export default class Country {

  /**
   * @constructor
   */
  constructor() {
    this.init();
  }

  init() {
    $(document).ready(() => {
      $('[data-paginationarrows="country"]').each((i, e) => {
        new PaginationArrows($(e));
      })
    })
  }
}